import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { t, isEmeaRegion } from '@insight/toolkit-utils';
import Button from '../Button/Button';

import { ProductDetailTabResource } from './ProductDetailTabResource';
import EnhancedCarousel from '../Carousel/EnhancedCarousel';
import RecommendedAccessories from '../RecommendedAccessories/RecommendedAccessories';

export const ProductDetailTabAccessories = ({
  disableNavLinks,
  limit,
  accessories,
  addToCart,
  showPrice,
  categoryType,
  showVAT,
  asyncPrice,
  richRelevanceSSEComplete,
  isIPSUserWithContract,
}) => {
  const [showMore, setShowMore] = useState(false);

  // Check if the product list contains items
  if (!accessories.length) {
    return <h5>{t('No Accessories found')}</h5>
  }
  // Set limit to accessories length or limit to 5
  const length = showMore ? accessories.length : limit;
  // Get visible accessories using the set limit
  const visibleAccessories = accessories.slice(0, length);
  const enhanceRecommendedAccessoriesLDFlag =
    window?.flags?.['GNA-14878-Enhance-Recommended-Accessories'];

  const config = {
    showVAT,
    showPrices: showPrice,
    showPartNumbers: true,
    showAddToBasketButton: false,
    useShortProductNames: false,
    isInCart: false,
    color: 'primary',
    fullWidth: false,
  };

  const renderResources = () => {
    if (!visibleAccessories.length) return <h5>{t('No Accessories found')}</h5>
    if (enhanceRecommendedAccessoriesLDFlag) {
      return (
        <EnhancedCarousel
          id="recommendedProductCarousel"
          indicator={false}
          slides={{
            mobile: 1,
            mobileLandscape: 2,
            tablet: 2,
            tabletLandscape: 2,
            desktop: 3,
          }}
        >
          {accessories.map((product, key) => (
            <RecommendedAccessories
              key={key}
              product={product}
              showAddToBasketButton={isEmeaRegion()}
              showAddToCartButton={!isEmeaRegion()}
              showPrice={showPrice}
              onAddToBasket={addToCart}
              config={config} // Pass the config here
              asyncPrice={asyncPrice}
              richRelevanceSSEComplete={richRelevanceSSEComplete}
              isIPSUserWithContract={isIPSUserWithContract}
              categoryType={categoryType}
              clickTrackingURL={product.clickTrackingURL}
              insightPrice={product?.price?.price}
              priceInclVat={product?.price?.priceInclVat}
              itemIndex={key}
              isAccessoryModal
              showVAT={showVAT}
              currency={product?.price?.currency}
            />
          ))}
        </EnhancedCarousel>
      );
    }
    return visibleAccessories.map((accessory = {}) => (
      <ProductDetailTabResource
        key={accessory.materialId}
        materialId={accessory.materialId}
        partNumber={accessory.manufacturerPartNumber}
        shortDescription={accessory.name}
        longDescription={accessory.description}
        cesSpecs={accessory.cesSpecs}
        clickTrackingURL={accessory.clickTrackingURL}
        priceInclVat={accessory?.price?.priceInclVat}
        insightPrice={accessory?.price?.price}
        currency={accessory?.price?.currency}
        disableNavLinks={disableNavLinks}
        image={{ url: accessory.image, description: accessory.description }}
        addToCart={addToCart}
        showPrice={showPrice}
        categoryType={categoryType}
        showVAT={showVAT}
        asyncPrice={asyncPrice}
        richRelevanceSSEComplete={richRelevanceSSEComplete}
        isIPSUserWithContract={isIPSUserWithContract}
      />
    ));
  };

  const renderViewMore = () =>
    showMore ? (
      <Button
        color="link"
        icon="remove"
        onClick={() => setShowMore(false)}
        aria-label={t('View less accessories')}
      >
        {t('View less accessories')}
      </Button>
    ) : (
      <Button
        color="link"
        icon="add"
        onClick={() => setShowMore(true)}
        aria-label={t('View more accessories')}
      >
        {t('View more accessories')}
      </Button>
    );

  return (
    <>
      {renderResources()}
      {!enhanceRecommendedAccessoriesLDFlag && (
        <div className="c-product-tabs__show-more">
          {accessories.length > limit && renderViewMore()}
        </div>
      )}
    </>
  );
};

export default ProductDetailTabAccessories;

ProductDetailTabAccessories.propTypes = {
  limit: PropTypes.number,
  disableNavLinks: PropTypes.bool,
  accessories: PropTypes.array,
  addToCart: PropTypes.func.isRequired,
};

ProductDetailTabAccessories.defaultProps = {
  limit: 3,
  disableNavLinks: true,
  accessories: [],
};
